import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

import { OPComponent, Container, NavBar, Navigation, DateUtils } from '../components';

class InviteRequestDetails extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Navigation.setButtons(
      {
        leftButtons: [NavBar.buttons.done],
      },
      this.props.componentId
    );
    Navigation.registerForButtonEvents(this);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  renderRow(label, value) {
    return (
      <View style={[__WEB__ ? THEME.basicRow : null, { marginBottom: 15 }]}>
        <Text style={styles.label}>{label}: </Text>
        <Text style={styles.value}>{value}</Text>
      </View>
    );
  }

  render() {
    const r = this.props.inviteRequest;
    return (
      <Container style={styles.container}>
        {this.renderRow('NAME', r?.details?.name)}
        {this.renderRow('SERVICE BRANCH', r?.details?.service_branch || '')}
        {this.renderRow('RANK', r?.details?.rank)}
        {this.renderRow('SQUADRON', r?.details?.squadron || r?.details?.group)}
        {this.renderRow('ROLE', r?.details?.role || 'Service Member')}
        {r?.details?.departmentName && this.renderRow('DEPARTMENT', r?.details?.departmentName)}
        {r?.details?.medicalService &&
          this.renderRow('MEDICAL SERVICE', r?.details?.medicalService)}
        {r?.details?.clinicalLocation &&
          this.renderRow('CLINICAL LOCATION', r?.details?.clinicalLocation)}
        {r?.details?.dod_id && this.renderRow('DOW ID', r?.details?.dod_id)}
        {this.renderRow('EMAIL ADDRESS', r?.details?.email)}
        {this.renderRow('MOBILE PHONE NUMBER', r?.details?.phone)}
        {this.renderRow('BIRTHDAY', DateUtils.formatDateStringNumeric(r?.details?.birthDate || ''))}
        {this.renderRow('DATE REQUESTED', DateUtils.formatDateStringNumeric(r?.created_at || ''))}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    padding: 35,
  },
  label: {
    ...FONT.regular,
    color: COLOR.textLight,
    width: 200,
    textAlign: __WEB__ ? 'right' : 'left',
  },
  value: {
    ...FONT.medium,
    color: COLOR.text,
    marginLeft: __WEB__ ? 15 : 0,
  },
});

export default InviteRequestDetails;
